// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useCallback, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import makeIltCourse from '../../redux/selectors/iltCourseInformationSelector';
import MainLayout from '../../layouts/MainLayout';
import LoadingIcon from '../../components/LoadingIcon';
import { S } from './IltCoursePageStyle';
import Row from '../../components/Row';
import Column from '../../components/Column';
import { parseDuration } from '../../lib/utility';
import Contents, { ContentsFromType } from '../../components/ContentsListComponent/Contents';
import ErrorPage from '../ErrorPage';
import FinishedBadgeIcon from '../../assets/images/card-badge.svg';
import { InfoTextType } from '../../components/NewCard/components/InfoText';
import { ILTCourse, Progress } from '../../types/Model';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { FormattedMessage } from 'react-intl';
import { FetchingParams } from '../../types/Common';
import CheckInRecord from './components/CheckInRecord';
import MemberContext from '../../contexts/MemberContext';
import moment from 'moment';
import Timer from './components/Timer';
import { getIltCourseAttendHistory, updateIltCourseAttendRecord } from './hooks';
import { isString } from 'lodash';

const {
  getIltCourseDataActions,
} = actionCreatorsList;

enum StatusEnum {
  firstTime = 'D002',
  keepGoing = 'D004',
  finish = 'D005',
  notAvailable = 'D024',
}

enum TimeEnum {
  untilcheckInTime = 'D047',
  checkInRemainTime = 'D048',
  untilcheckOutTime = 'D049',
  checkOutRemainTime = 'D050',
  checkInTime = 'D052',
  checkOutTime = 'D053',
}

const useFetchIltCourseInformation = (id: number, params?:FetchingParams) => {
  const dispatch = useDispatch();
  const preventLoading = params && params.preventLoading;
  const callback = params && params.callback;

  const fetch = useCallback(() => {
    dispatch(getIltCourseDataActions.request({ id, preventLoading }))
    callback && callback();
  }, [id, preventLoading, callback])

  return fetch;
}

function useUpdateProgress(id: number): (progress: Progress) => void {
  const dispatch = useDispatch();
  const refetchContents = useFetchIltCourseInformation(id, { preventLoading: true });

  return useCallback((progress: Progress) => {
    dispatch(actionCreatorsList.updateIltCourseProgressActions.request({
      id,
      progress,
      onSuccess: () => refetchContents()
    }))
  }, [id])
}

type Status = StatusEnum.firstTime | StatusEnum.finish | StatusEnum.notAvailable | StatusEnum.keepGoing; //| StatusEnum.freeTrial;

function getIltCourseStatus(iltCourse: ILTCourse) {
  if (iltCourse.hasCourse) {
    if (iltCourse.completionProgress === 0) {
      return StatusEnum.firstTime;
    } else if (iltCourse.completionProgress === 1) {
      return StatusEnum.finish;
    } else {
      return StatusEnum.keepGoing;
    }
  }

  return StatusEnum.notAvailable;
}

const IltCoursePage = (): JSX.Element => {
  const params = useParams<{ id: string }>();
  const id = parseInt(params.id, 10);
  const member = useContext(MemberContext);
  const isFetching = useSelector(makeIltCourse.makeIsFetchingIltCourse());
  const iltCourse = useSelector(makeIltCourse.makeIltCourseByIdSelector(id));
  const { chapters = [] } = iltCourse;
  const errors = useSelector(makeIltCourse.makeError());
  const [status, setStatus] = useState<Status>(StatusEnum.notAvailable);
  const [hoverType, setHoverType] = useState<any>(null);

  const fetchIltCourse = useFetchIltCourseInformation(id);
  const updateProgress = useUpdateProgress(id);

  const [checkRecord, setCheckRecord] = useState<any>([]);
  const [showCheckRecord, setShowCheckRecord] = useState(false);
  const [checkRecordLoading, setCheckRecordLoading] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);
  const [checkRecordError, setCheckRecordError] = useState<string>('');

  useEffect(() => {
    fetchIltCourse();
  }, [id]);

  useEffect(() => {
    setStatus(getIltCourseStatus(iltCourse));
  }, [iltCourse]);

  const openCheckRecord = async () => {
    setCheckRecordLoading(true);
    setShowCheckRecord(true);
    await getIltCourseAttendHistory(id).then((res: any) => {
      if (isString(res)) {
        setCheckRecordError(res);
      } else {
        setCheckRecord(res);
      }
    }).finally(() => setCheckRecordLoading(false));
  }

  const closeShowCheckRecord = () => {
    setCheckRecord([]);
    setCheckRecordError('');
    setShowCheckRecord(false);
  }

  const updateAttend = async (type: string) => {
    setCheckLoading(true)
    await updateIltCourseAttendRecord(id, type).then((res: any) => {
      fetchIltCourse();
      setCheckLoading(false)
    }).catch((e: any) => {
      console.log(e)
    })
  }

  function renderAttendRecordButton() {

    return (
      <>
        <S.DownloadResultContainer>
          <S.DownloadButtonContainer>
            <S.Button onClick={() => openCheckRecord()}>
              <FormattedMessage id="D051" />
            </S.Button>
          </S.DownloadButtonContainer>
          { showCheckRecord ? <CheckInRecord loading={checkRecordLoading} refresh={openCheckRecord} data={checkRecord} error={checkRecordError} closeShowCheckRecord={closeShowCheckRecord}/> : null }
        </S.DownloadResultContainer>
      </>
    )
  }

  const ChecKInOut = () => {
    const [intervalCount, setIntervalCount] = useState(0);
    const now = moment(new Date());
    const startTime = new Date(iltCourse.startTime);
    const endTime = new Date(iltCourse.endTime);
    const checkInRange = [moment(startTime).subtract(10, 'minutes'), moment(startTime).add(20, 'minutes')]
    const checkOutRange = [moment(endTime).subtract(10, 'minutes'), moment(endTime).add(20, 'minutes')]
    const inCheckInTime = now > checkInRange[0] && now < checkInRange[1]
    const inCheckOutTime = now > checkOutRange[0] && now < checkOutRange[1]

    const countEnd = now < checkInRange[0] ? checkInRange[0] : inCheckInTime ? checkInRange[1] : now < checkOutRange[0] ? checkOutRange[0] : inCheckOutTime ? checkOutRange[1] : null

    useEffect(() => {
      setTimeout(() => {
        setIntervalCount(count => count + 1);
      }, 2000);
    }, [intervalCount])

    return (
      <S.CheckContainer>
        <S.BtnContainer
          onMouseEnter={() => { setHoverType('in') }}
          onMouseLeave={() => { setHoverType(null) }}
        >
          <S.Button
            disabled={!inCheckInTime || iltCourse.checkInTime !== null}
            onClick={() => { updateAttend('check_in_time') }}
          >
            { iltCourse.checkInTime ? (<S.CheckIcon/>) : inCheckInTime && checkLoading ? <LoadingIcon size={3}/> : null }
            <FormattedMessage id={'D045'} />
            { inCheckInTime && !iltCourse.checkInTime && !checkLoading ? (<S.AlarmIcon/>) : null }
          </S.Button>
          <S.Tooltips show={hoverType === 'in' && inCheckInTime && !iltCourse.checkInTime}>
            { countEnd && (
              <S.CheckInfo>
                <FormattedMessage id={TimeEnum.checkInRemainTime} />
                <Timer
                  endTime={countEnd.toDate()}
                />
              </S.CheckInfo>
            ) }
          </S.Tooltips>
          <S.Tooltips show={hoverType === 'in' && iltCourse.checkInTime !== null}>
            <S.CheckInfo>
              <FormattedMessage id={TimeEnum.checkInTime} values={{ br: <br/>, time: moment(iltCourse.checkInTime).format('YYYY/MM/DD HH:mm') }} />
            </S.CheckInfo>
          </S.Tooltips>
        </S.BtnContainer>
        <S.BtnContainer
          onMouseEnter={() => { setHoverType('out') }}
          onMouseLeave={() => { setHoverType(null) }}
        >
          <S.Button
            disabled={!inCheckOutTime || iltCourse.checkOutTime !== null}
            onClick={() => { updateAttend('check_out_time') }}
          >
            { iltCourse.checkOutTime ? (<S.CheckIcon/>) : inCheckOutTime && checkLoading ? <LoadingIcon size={3}/> : null }
            <FormattedMessage id={'D046'} />
            { inCheckOutTime && !iltCourse.checkOutTime && !checkLoading ? (<S.AlarmIcon/>) : null }
          </S.Button>
          <S.Tooltips show={hoverType === 'out' && inCheckOutTime && !iltCourse.checkOutTime}>
            { countEnd && (
              <S.CheckInfo>
                <p><FormattedMessage id={TimeEnum.checkOutRemainTime} /></p>
                <Timer
                  endTime={countEnd.toDate()}
                />
              </S.CheckInfo>
            ) }
          </S.Tooltips>
          <S.Tooltips show={hoverType === 'out' && iltCourse.checkOutTime !== null}>
            <S.CheckInfo>
              <FormattedMessage id={TimeEnum.checkOutTime} values={{ br: <br/>, time: moment(iltCourse.checkOutTime).format('YYYY/MM/DD HH:mm') }}/>
            </S.CheckInfo>
          </S.Tooltips>
        </S.BtnContainer>
      </S.CheckContainer>
    )
  }

  if (isFetching) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <LoadingIcon size={20} />
        </S.LoadingContainer>
      </MainLayout>
    );
  }
  if (errors) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <ErrorPage />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <S.WrapperTop>
        <S.Container>
          <Row alignX="between">
            <S.LeftWrapper>
              <S.Title color="Black">{iltCourse.name}</S.Title>
              <S.Instructors>
                {iltCourse.instructors ? iltCourse.instructors.join(',') : iltCourse.instructors}
              </S.Instructors>
            </S.LeftWrapper>
            <S.RightWrapper>
              {status === StatusEnum.finish && <S.Badge src={FinishedBadgeIcon} alt="" />}
              <S.Information>
                <S.Description color="Black">{iltCourse.description}</S.Description>
                {status === StatusEnum.notAvailable && iltCourse.contactEmail && (
                  <S.Description color="Black"><FormattedMessage id={'E077'} /><S.Email>{iltCourse.contactEmail}</S.Email></S.Description>
                )}
              </S.Information>
            </S.RightWrapper>
          </Row>
        </S.Container>
      </S.WrapperTop>
      <S.Body>
        <S.Container>
          <Row>
            <S.InfoBox>
              { (iltCourse.labCount != 0 || iltCourse.challengeCount != 0 || iltCourse.examCount != 0) && (
                <S.InfoText highlight={true} type={InfoTextType.HIGHTLIGHTDURATION}>
                  <FormattedMessage id="D054" values={{timeString: moment(iltCourse.endTime).add(1, 'months').format('YYYY/MM/DD HH:mm')}}/>
                  <div style={{ whiteSpace: 'nowrap' }}>
                    <S.InfoIcon
                      onMouseEnter={() => { setHoverType('info') }}
                      onMouseLeave={() => { setHoverType(null) }}
                    />
                    <S.InfoTooltips show={hoverType === 'info'}>
                      <FormattedMessage id={'D055'} />
                    </S.InfoTooltips>
                  </div>
                </S.InfoText>)}
              { status === StatusEnum.notAvailable ? (
                <S.Button
                  disabled={status === StatusEnum.notAvailable}
                >
                  <FormattedMessage id={StatusEnum.notAvailable} />
                </S.Button>
              ) : (
                <ChecKInOut/>
              )}
              {iltCourse.isCourseOwner ? renderAttendRecordButton() : null}
              <Column gap={12}>
                <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="B015" values={{timeString: moment(iltCourse.startTime).format('YYYY/MM/DD HH:mm')}}/></S.InfoText>
                <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="B016" values={{timeString: moment(iltCourse.endTime).format('YYYY/MM/DD HH:mm')}}/></S.InfoText>
                <S.InfoText type={InfoTextType.DURATION}><FormattedMessage id="D011" />{parseDuration(iltCourse.totalDuration).auto}</S.InfoText>
                <S.InfoText type={InfoTextType.LANGUAGE}><FormattedMessage id="B014" values={{lang: iltCourse.language}}/></S.InfoText>
                <S.InfoText type={InfoTextType.LOCATION}><FormattedMessage id="B064" values={{location: iltCourse.location}}/></S.InfoText>
                {iltCourse.vodCount != 0 && (<S.InfoText type={InfoTextType.VOD}><FormattedMessage id="D012" values={{ count: iltCourse.vodCount }}/></S.InfoText>)}
                {iltCourse.labCount != 0 && (<S.InfoText type={InfoTextType.LAB}><FormattedMessage id="D013" values={{ count: iltCourse.labCount }}/></S.InfoText>)}
                {iltCourse.challengeCount != 0 && (<S.InfoText type={InfoTextType.CHALLENGE}><FormattedMessage id="D025" values={{ count: iltCourse.challengeCount }}/></S.InfoText>)}
                {iltCourse.examCount != 0 && (<S.InfoText type={InfoTextType.EXAM}><FormattedMessage id="D028" values={{ count: iltCourse.examCount }}/></S.InfoText>)}
                {iltCourse.assessmentCount != 0 && (<S.InfoText type={InfoTextType.ASSESSMENT}><FormattedMessage id="D014" values={{ count: iltCourse.assessmentCount }}/></S.InfoText>)}
              </Column>
            </S.InfoBox>
            <S.Contents>
              <Contents handleUpdateProgress={updateProgress} chapters={chapters} id={id} contentsFrom={ContentsFromType.ILT_COURSE} isOwned={iltCourse.hasCourse ? iltCourse.hasCourse : false} />
            </S.Contents>
          </Row>
        </S.Container>
      </S.Body>
    </MainLayout>
  )
}

export { IltCoursePage as default };
